import React from "react";
import "./Card.scss";
import Product from "./Json";

const Card = () => {
  return (
    <section className="service-section">
      <div className="container">
        <h2 className="section-title">What You’ll Get From Us</h2>

        <div className="card-grid">
          {Product.map((item) => (
            <div className="card" key={item.id}>
              <div className="icon-wrapper">{item.icon}</div>
              <h3>{item.head}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Card;
